{
    "tasks__search_placeholder": "Suche nach Aufgaben",
    "tasks_overview_table__header__title": "Aufgabe",
    "tasks_overview_table__header__due_date": "Fällig bis",
    "tasks_overview_table__header__completed_at": "Erledigt am",
    "tasks_overview_table__header__related_to": "Bezug",
    "tasks_overview_table__header__assigned_to_user": "Zu erledigen von",
    "tasks_overview_table__header__assigned_by_user": "Erstellt von",
    "tasks_overview_table__attachments_count_aria_one": "{{count}} Anhang anzeigen",
    "tasks_overview_table__attachments_count_aria_other": "{{count}} Anhänge anzeigen",
    "filter_menu_title__customers": "Kunden",
    "filter_menu_title__orders": "Aufträge",
    "filter_menu_title__quotes": "Angebote",
    "filter_menu_title__assigned_tos": "Zu erledigen von",
    "filter_menu_title__assigned_bys": "Erstellt von",
    "tasks__group_today": "Heute",
    "tasks__group_upcoming": "Anstehend",
    "tasks__group_completed": "Erledigt",
    "tasks__quick_filters__to_me": "Von mir zu erledigen",
    "tasks__quick_filters__by_me": "Von mir erstellt",
    "tasks__empty_state__body": "Hier gibt es noch keine Aufgaben. Nutze Aufgaben, um Dinge zu delegieren oder dir eine Erinnerung zu stellen",
    "tasks__empty_state__create_task": "Neue Aufgabe erstellen",
    "tasks__delete_confirmation__title": "Aufgabe löschen?",
    "tasks__delete_confirmation__body": "Die Aufgabe wird dauerhaft gelöscht. Diese Aktion kann nicht rückgängig gemacht werden.",
    "task_overview_table__options_aria": "Aufgabenoptionen",
    "task_overview_table__options__edit_task": "Aufgabe bearbeiten",
    "task_overview_table__options__delete_task": "Aufgabe löschen",
    "tasks__assigned_to_placeholder": "Nutzer auswählen",
    "tasks__assigned_to_placeholder_multiple": "Nutzer auswählen (mehrere möglich)",
    "tasks_open_tasks": "Offene Aufgaben",
    "overdue": "Überfällig",
    "due_today": "Heute fällig",
    "details__title": "Aufgabe",
    "tasks__form_create_title": "Aufgabe erstellen",
    "tasks__form_edit_title": "Aufgabe",
    "tasks__form_create_submit_zero": "Aufgabe erstellen",
    "tasks__form_create_submit_one": "Aufgabe erstellen",
    "tasks__form_create_submit_other": "{{count}} Aufgaben erstellen",
    "tasks__description_placeholder": "Aufgabe beschreiben",
    "tasks__toast__created_one": "Aufgabe erfolgreich erstellt",
    "tasks__toast__created_other": "{{count}} Aufgaben erfolgreich erstellt",
    "tasks__toast__edited_success_title": "Aufgabe erfolgreich bearbeitet",
    "tasks__toast__success_body": "Du kannst sie hier <linkTag>ansehen</linkTag>",
    "tasks__toast__deleted_success_title": "Aufgabe erfolgreich gelöscht",
    "tasks__entity_search__placeholder": "Suche nach Kunde, Auftrag oder Angebot",
    "form__complete_task": "Als erledigt markieren",
    "form__open_task": "Aufgabe wieder öffnen",
    "tasks__form__created_by_label": "Erstellt von",
    "tasks__form__download_file": "Herunterladen",
    "tasks__form__download_error": "Datei konnte nicht heruntergeladen werden",
    "tasks__form__edit_file": "Bearbeiten",
    "tasks__form__delete_attachment_confirmation__title": "Anhang löschen",
    "tasks__form__delete_attachment_confirmation__body": "Der Anhang wird entfernt. Diese Aktion kann nicht rückgängig gemacht werden.",
    "task_not_found": "Aufgabe nicht gefunden",
    "status_OPEN": "Offen",
    "status_COMPLETED": "Erledigt",
    "comments__section_title": "Aktivität",
    "comments__add_placeholder": "Kommentar hinzufügen...",
    "comments__save": "Speichern",
    "comments__edit": "Bearbeiten",
    "comments__delete": "Löschen",
    "comments__edited": "(bearbeitet)",
    "comments__delete_confirmation__title": "Kommentar löschen",
    "comments__delete_confirmation__body": "Der Kommentar wird dauerhaft gelöscht. Diese Aktion kann nicht rückgängig gemacht werden.",
    "comments__toast__deleted_success_title": "Kommentar erfolgreich gelöscht",
    "comments__toast__updated_success_title": "Kommentar erfolgreich aktualisiert",
    "table_header__task": "Aufgabe",
    "task_column__create_task_tooltip": "Aufgabe erstellen",
    "task_column__tasks_count_one": "{{count}} Aufgabe",
    "task_column__tasks_count_other": "{{count}} Aufgaben"
}
